import React from 'react'

function AnalyticsDashboard() {
  return (
    <div>AnalyticsDashboard</div>
  )
}

export default AnalyticsDashboard